// Add your custom JS here

document.addEventListener("DOMContentLoaded", (event) => {
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { 
      if (entry.isIntersecting) {
        entry.target.classList.add('did-animate'); 
      }
    });
  });

  const fadeAnimations = document.querySelectorAll(`
    #content p,
    #content a:not(li a):not(.card a),
    #content h2,
    #content h3,
    #content h4,
    #content li,
    #content figure 
  `);

  for (let el of fadeAnimations) {
    el.setAttribute('data-anim-fade', '');
    observer.observe(el)
  }

  // const imageAnimations = document.querySelectorAll(`#content img`);
  // for (let img of imageAnimations) {
  //   img.setAttribute('data-anim-fade', '');
  //   img.onload = () => {
  //     observer.observe(img);
  //   }
  // }
});

jQuery(function ($) {
  $(document).ready(function () {
    // $(".navbar #searchform .search-btn").click(function (e) {
    //   if ($(".navbar #searchform").hasClass("visible") === false) {
    //     $(".navbar #searchform").addClass("visible");
    //     e.preventDefault();
    //   } else {
    //     if ($(".navbar #searchform .form-control").val() === "") {
    //       $(".navbar #searchform").removeClass("visible");
    //       e.preventDefault();
    //     }
    //   } 
    // });
  });
});
